import Head from "next/head";
import { useContext } from "react";
import { useRouter } from "next/router";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";

import { ChatContext } from "contexts/chat";
import { isMobile } from "@/utils/deviceJudgment";
import { unreadCountAtom } from "@/states/chat/unreadCountAtom";

type Props = {
  title: string;
  keyword: string;
  description: string;
  image: string;
  noindex?: boolean; //これで合ってる？
};

const CommonHead: React.FC<Props> = ({
  title,
  keyword,
  description,
  image,
  noindex
}) => {
  const router = useRouter();
  const { isConnected } = useContext<any>(ChatContext);
  const unreadCount = useAtomValue(unreadCountAtom);
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  //モバイル端末か判定
  useEffect(() => {
    setIsMobileDevice(isMobile() ? true : false);
  }, []);

  return (
    <Head>
      <meta charSet="utf-8" />
      <meta
        name="viewport"
        content="width=device-width,initial-scale=1.0,maximum-scale=1.0"
      />
      {(process.env.APP_ENV_TEXT === "dev" || noindex) && (
        <meta name="robots" content="noindex" />
      )}
      <title>{`${title}${
        isConnected
          ? unreadCount > 0
            ? ` -【新着チャットがあります】`
            : ""
          : isMobileDevice
            ? ""
            : !router.asPath.startsWith("/guest/")
              ? " -【チャット受信停止中】"
              : ""
      }`}</title>
      <meta name="keywords" content={keyword} />
      <meta property="description" content={description} />
      <meta
        property="og:title"
        content={
          image === "https://www.cosoji.jp/common/images/ogp/ogp_app.png"
            ? "COSOJI : 不動産管理を安く・楽に・適切に！"
            : title
        }
      />
      <meta property="og:description" content={description} />
      <meta
        property="og:url"
        content={process.env.APP_FRONT_URL + router.asPath}
      />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="COSOJI" />
      <meta property="og:locale" content="ja_JP" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@cosoji_jp" />
      <meta
        name="twitter:url"
        content={process.env.APP_FRONT_URL + router.asPath}
      />
      <meta
        name="twitter:title"
        content={
          image === "https://www.cosoji.jp/common/images/ogp/ogp_app.png"
            ? "COSOJI : 不動産管理を安く・楽に・適切に！"
            : title
        }
      />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <link rel="canonical" href={process.env.APP_FRONT_URL + router.asPath} />
      <link rel="icon" href={`${process.env.APP_FRONT_URL}/favicon.ico`} />
      <link
        rel="apple-touch-icon"
        href={`${process.env.APP_FRONT_URL}/logo192.png`}
      />
      <link
        rel="manifest"
        href={`${process.env.APP_FRONT_URL}/manifest.json`}
      />
    </Head>
  );
};

export default CommonHead;
